import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/print/prints`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/print/prints/${url.id}`, config),
};

export default requests;
